// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"3ab49aad","98":"3a810879","138":"4e8f6446","222":"68100065","353":"3dad8a4b","429":"32f32b5e","486":"818e25f9","567":"115efec7","665":"7d0fd2f9","783":"3c160a3e","791":"55b74695","804":"af0af0e5","826":"e353f018","866":"2b2f2cf4"}[chunkId] + ".chunk.js";
};